<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div *ngIf="!isLoading && orderProcess$ | async as orderProcess" class="component-container">
  <form *ngIf="resultForm && isModerator" [formGroup]="resultForm">
    <div class="margin-align">
      <div class="margin-header-align text-uppercase page-title">{{ 'grid-comp.result.title' | translate }}</div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 ui-g-offset-2 field-label required">
          {{ 'grid-comp.result.level' | translate }}
        </label>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="level"
          id="level-high-voltage"
          label="{{ 'grid-comp.result.level-high-voltage' | translate }}"
          class="p-field-radio"
          name="level"
          [value]="enums.level.HighVoltage"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="level"
          id="level-medium-voltage"
          label="{{ 'grid-comp.result.level-medium-voltage' | translate }}"
          class="p-field-radio"
          name="level"
          [value]="enums.level.MediumVoltage"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="level"
          id="level-low-voltage"
          label="{{ 'grid-comp.result.level-low-voltage' | translate }}"
          class="p-field-radio"
          name="level"
          [value]="enums.level.LowVoltage"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 ui-g-offset-2 field-label required">
          {{ 'grid-comp.result.transformation' | translate }}
        </label>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="transformation"
          id="transformation-high-to-medium-voltage"
          label="{{ 'grid-comp.result.transformation-high-to-medium-voltage' | translate }}"
          class="p-field-radio"
          name="transformation"
          [value]="enums.transformation.HighToMediumVoltage"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="transformation"
          id="transformation-medium-to-low-voltage"
          label="{{ 'grid-comp.result.transformation-medium-to-low-voltage' | translate }}"
          class="p-field-radio"
          name="transformation"
          [value]="enums.transformation.MediumToLowVoltage"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="transformation"
          id="transformation-no-station"
          label="{{ 'grid-comp.result.transformation-no-station' | translate }}"
          class="p-field-radio"
          name="transformation"
          [value]="enums.transformation.NoTransformerStation"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 ui-g-offset-2 field-label">
          {{ 'grid-comp.result.net-congestion-power' | translate }}
        </label>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-4 field-label text-right-align required">
          {{ 'grid-comp.result.feed-in-power' | translate }}
        </label>
        <input class="ui-input pInputText" pInputText name="feedInPower" formControlName="feedInPower" type="number" />
        <span class="unit-margin">{{ 'grid-comp.result.power-units' | translate }}</span>
      </div>

      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-4 field-label text-right-align required">
          {{ 'grid-comp.result.power-demand' | translate }}
        </label>
        <input class="ui-input pInputText" pInputText name="powerDemand" formControlName="powerDemand" type="number" />
        <span class="unit-margin">{{ 'grid-comp.result.power-units' | translate }}</span>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 ui-g-offset-2 field-label required">
          {{ 'grid-comp.result.grid-connection-type' | translate }}
        </label>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="type"
          id="vde-ar-4105-grid-connection"
          label="{{ 'grid-comp.result.vde-ar-4105-grid-connection' | translate }}"
          class="p-field-radio"
          name="type"
          [value]="enums.type.vdeAr4105"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="type"
          id="vde-ar-4110-grid-connection"
          label="{{ 'grid-comp.result.vde-ar-4110-grid-connection' | translate }}"
          class="p-field-radio"
          name="type"
          [value]="enums.type.vdeAr4110"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="type"
          id="vde-ar-4120-grid-connection"
          label="{{ 'grid-comp.result.vde-ar-4120-grid-connection' | translate }}"
          class="p-field-radio"
          name="type"
          [value]="enums.type.vdeAr4120"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 ui-g-offset-2 field-label required">
          {{ 'grid-comp.result.in-accordance-with-vde-standard' | translate }}
        </label>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="isAccordingToVDEStandard"
          id="isAccordingToVDEStandard"
          label="{{ 'grid-comp.yes' | translate }}"
          class="p-field-radio"
          name="isAccordingToVDEStandard"
          [value]="true"></p-radioButton>
      </div>
      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          formControlName="isAccordingToVDEStandard"
          id="isAccordingToVDEStandard"
          label="{{ 'grid-comp.no' | translate }}"
          class="p-field-radio"
          name="isAccordingToVDEStandard"
          [value]="false"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-12 ui-sm-12 ui-xs-12 field-rows section-field">
        <label class="ui-g-2 field-label text-right-align">
          {{ 'grid-comp.result.assessment-of-grid-document' | translate }}
        </label>
        <div class="ui-lg-10 ui-xs-12 upload-padding">
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            [isRequired]="false"
            [fileData]="resultForm.value.gridAssessmentDocument"
            inputName="gridAssessmentDocument"
            [isDetailsView]="
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionIssued ||
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionExpired ||
              isGridAssessmentDocumentUploaded
            "
            [isRequired]="false"
            [type]="enums.documentTypes.AssesmentOfGrid"
            [isClearButtonDisabled]="resultForm.disabled"
            [isUploadDisabled]="resultForm.disabled"
            (fileDataChangeEvent)="changeFileData($event)"></app-file-upload>
        </div>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-12 ui-sm-12 ui-xs-12 field-rows section-field">
        <label class="ui-g-2 field-label text-right-align">
          {{ 'grid-comp.result.site-plan-document' | translate }}
        </label>
        <div class="ui-lg-10 ui-xs-12 upload-padding">
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            [isRequired]="false"
            [fileData]="resultForm.value.sitePlan"
            inputName="sitePlan"
            [isDetailsView]="
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionIssued ||
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionExpired ||
              isSitePlanDocumentUploaded
            "
            [isRequired]="false"
            [type]="enums.documentTypes.SitePlan"
            [isClearButtonDisabled]="resultForm.disabled"
            [isUploadDisabled]="resultForm.disabled"
            (fileDataChangeEvent)="changeFileData($event)"></app-file-upload>
        </div>
      </div>
    </div>

    <div *ngIf="'app.calendar-settings' | translate as locale" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-2 field-label text-right-align required">
          {{ 'grid-comp.result.feed-in-permission' | translate }}
        </label>
        <div class="ui-lg-10 ui-xs-12 upload-padding">
          <p-calendar
            tabIndex="0"
            appCalendarEscapeClose
            [locale]="locale"
            [dateFormat]="dateFormat.dateFormat"
            [placeholder]="dateFormat.placeholder"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [minDate]="minDate"
            class="doc-submit-datepicker"
            dateFormat="string"
            formControlName="feedInPermissionValidDate"
            id="feedInPermissionValidDate"
            inputId="basic"
            yearRange="2023:2080"></p-calendar>
        </div>
      </div>
    </div>
  </form>

  <!-- CURRENT STATUS -->
  <div class="margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'overview.process-details.order-process-title' | translate }}</div>
  </div>
  <div class="standard-offer-row ui-g-12 form-font-size mt-3">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g field-label">
        <b>
          {{ 'overview.process-details.current-status' | translate }} :
          {{ 'grid-comp.order-process.' + enums.orderProcessStatus[orderProcess.status] | translate }}
        </b>
      </div>
    </div>

    <div
      *ngIf="!isModerator && orderProcess.result && orderProcess.status === enums.orderProcessStatus.FeedInPermissionIssued"
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g field-label">
        <b>
          {{ 'grid-comp.feed-in-permission-date' | translate }} :
          {{ orderProcess.result.feedInPermissionValidDate.toLocaleDateString('de-DE') }}
        </b>
      </div>
    </div>
    <div *ngIf="showCopyApplication" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g field-label">
        <b>{{ 'grid-comp.result.proceed-regep-request-info' | translate }}</b>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      orderProcess.status !== enums.orderProcessStatus.RequestDenied && orderProcess.status !== enums.orderProcessStatus.RequestWithdrawn
    "
    class="standard-offer-row ui-g-12 form-font-size">
    <ng-container *ngIf="!isModerator">
      <div
        *ngIf="orderProcess.status === enums.orderProcessStatus.OpenIssue && isApplicationOwner"
        class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
        <button
          class="view-btn-width"
          (click)="updateRequest(orderProcess.id)"
          id="update-request-btn"
          label="{{ 'grid-comp.result.update-request-button' | translate }}"
          pButton
          type="button"></button>
      </div>
      <div
        *ngIf="
          (isApplicationOwner || isBusinessPartner) &&
          (orderProcess.status === enums.orderProcessStatus.FeedInPermissionExpired ||
            orderProcess.status === enums.orderProcessStatus.ExtensionOfFeedInPermissionRequested)
        "
        class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
        <button
          class="view-btn-width"
          (click)="requestExtension(orderProcess.id)"
          [disabled]="orderProcess.status === enums.orderProcessStatus.ExtensionOfFeedInPermissionRequested"
          id="request-extension-btn"
          label="{{ 'grid-comp.result.request-extension-button' | translate }}"
          pButton
          type="button"></button>
      </div>
      <div *ngIf="isApplicationOwner" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
        <button
          class="view-btn-width"
          (click)="withdrawRequest(orderProcess.id)"
          id="withdraw-request-btn"
          label="{{ 'grid-comp.result.withdraw-request-button' | translate }}"
          pButton
          type="button"></button>
      </div>
      <div *ngIf="isApplicationOwner" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
        <button
          class="view-btn-width"
          (click)="withdrawAndCopyRequest(orderProcess.id)"
          id="withdraw-and-copy-request-btn"
          label="{{ 'grid-comp.result.withdraw-and-copy-request-button' | translate }}"
          pButton
          type="button"></button>
      </div>
      <div *ngIf="showCopyApplication" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
        <button
          class="view-btn-width"
          (click)="copyToRegepRequest()"
          id="copy-request-regep-btn"
          label="{{ 'grid-comp.result.copy-request-regep-button' | translate }}"
          pButton
          type="button"></button>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        isModerator &&
        (orderProcess.status === enums.orderProcessStatus.RequestSent ||
          orderProcess.status === enums.orderProcessStatus.RequestUpdated ||
          orderProcess.status === enums.orderProcessStatus.FeedInPermissionIssued ||
          orderProcess.status === enums.orderProcessStatus.FeedInPermissionExpired ||
          orderProcess.status === enums.orderProcessStatus.ExtensionOfFeedInPermissionRequested)
      ">
      <div class="mt-3">
        <div *ngIf="resultForm" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
          <button
            class="view-btn-width"
            (click)="issuePermission(orderProcess.id, resultForm.value, resultForm.value.sitePlan, resultForm.value.gridAssessmentDocument)"
            [disabled]="!canIssuePermission(resultForm, orderProcess)"
            id="issue-permission-btn"
            label="{{ 'grid-comp.result.issue-permission-button' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
          <button
            class="view-btn-width"
            id="resolve-btn"
            (click)="resolveIssue(orderProcess.id)"
            label="{{ 'grid-comp.result.resolve-issue-button' | translate }}"
            [disabled]="
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionIssued ||
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionExpired ||
              !gridCompatibilityService.areAllSectionsReviewed()
            "
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
          <button
            class="view-btn-width"
            id="deny-request-btn"
            (click)="denyRequest(orderProcess.id)"
            label="{{ 'grid-comp.result.deny-request-button' | translate }}"
            [disabled]="
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionIssued ||
              orderProcess.status === enums.orderProcessStatus.FeedInPermissionExpired
            "
            pButton
            type="button"></button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
